var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.logo)?_c('v-avatar',{attrs:{"size":_vm.size,"height":_vm.size}},[(_vm.lazy)?_c('VImg',{attrs:{"src":_setup.logo,"alt":"bank logo"}}):_c('img',{attrs:{"src":_setup.logo,"alt":"bank logo"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }